import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function createJiraTicketReducer(
  state = initialState.shouldCreateJiraTicket,
  action
) {
  // avoiding state mutation, while updating nested states.
  switch (action.type) {
    case types.TOGGLE_CREATE_JIRA_TICKET:
      return action.data;
    default:
      return state;
  }
}
